import type { JSONSchema } from '@plone/types';

export function addFormWidth(
  schema: JSONSchema,
  title: string,
  actions: string[],
): JSONSchema {
  const stylesSchema = schema.properties.styles.schema;

  stylesSchema.fieldsets[0].fields = [
    'blockWidth:noprefix',
    ...stylesSchema.fieldsets[0].fields,
  ];
  stylesSchema.properties['blockWidth:noprefix'] = {
    widget: 'blockWidth',
    title,
    default: 'default',
    actions,
  };

  return schema;
}
